import React, {Component} from "react";
import {Button} from "primereact/button";
import PresvalUploadFileView from "../PresvalUploadFileView";
import {Growl} from "primereact/growl";
import {FileService} from "../../../service/file/FileService";
import PropTypes from "prop-types";

/**
 * Componente genérico para subir documentos.
 * Sólo se debe incluir en la vista o donde se quiera llamar,
 * con los parámetros que se indican.
 */
export default class UploadFileContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     * Los parámetros que se le pueden poner a este componente son:
     * type: Es el tipo de archivo que recibe, con esto se va a comparar que el
     *      documento sea del mismo tipo.
     *      *Es un dato obligatorio
     * size: Tamaño máximo del archivo.
     *      *Es un dato obligatorio.
     * urlAction: Es la url que se colocará en la petición del back para subir
     *            el archivo.
     *            *Es un dato obligatorio.
     * className: Se usa igual que el del componente botón, para cambiar la apariencia
     *            del botón para buscar el archivo. No es obligatorio.
     * titleHeader: Título que se mostrará en el header del cuadro de diálogo.
     *              No es obligatorio, sino viene se mostrará: "Cargar Archivo Disponible"
     * titleButton: Texto que se mostrará en el botón.
     *              No es obligatorio, sino viene se mostrará: "Cargar Archivo"
     * errorTypeMessage: Mensaje que se mostrará cuando haya un error en el tipo de archivo.
     *              No es obligatorio, sino viene se mostrará: "Error en tipo de documento"
     * errorSizeMessage: Mensaje que se mostrará cuando haya un error en el tamaño del archivo.
     *              No es obligatorio, sino viene se mostrará: "Error en tamaño de documento"
     * instructions: Texto informativo que se muestra en el cuadro de diálogo. No es obligatorio
     * params: Parámetros que puede llevar la petición al back. Debe ser del tipo objeto:
     *         {llave: valor, llave: valor} para poder mandarlos como parámetros.
     *         No es obligatorio.
     * action: Función a la cual se va a reedirigir cuando termine de subir el archivo
     *         Por ejemplo, si se quisiera cargar de nuevo una tabla, se manda esa función.
     *         No es obligatorio."
     */
    constructor(props) {
        super(props);
        this.fileService = new FileService();
        this.state = {
            displayDialog: false,
            displayDialogPreview: false,
            fileToSave: null,
            fileName: '',
            visibleUploadResDialog: false,
            headerUploadResDialog: '',
            uploadResTemplate:''
        };
        this.openUploadFile = this.openUploadFile.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.onUpload = this.onUpload.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.onHidePreviewDialog = this.onHidePreviewDialog.bind(this);
        this.getButtonOpen = this.getButtonOpen.bind(this);
        this.getDialogHeader = this.getDialogHeader.bind(this);
        this.getDialogPreviewHeader = this.getDialogPreviewHeader.bind(this);
    }

    /**
     * Función que abre el cuadro de diálogo para subir el archivo.
     */
    openUploadFile() {
        this.setState({
            fileToSave: null,
            displayDialog: true,
            fileName: '',
        });
    }

    /**
     * Función que revisa si el archivo cumple con las especificaciones
     * de tipo y tamaño.
     * @param event Objeto que contiene la información del archivo.
     */
    onUpload(event) {
        let files = event.target.files;
        if (this.props.type.find(function (find){return files[0].type === find}) === undefined) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: (this.props.errorTypeMessage ?
                    this.props.errorTypeMessage : "Error en tipo de documento")
            });
        } else if (files[0].size >= this.props.size) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: (this.props.errorSizeMessage ?
                    this.props.errorSizeMessage : "Error en tamaño de documento")
            });
        } else if(files[0].size === 0){
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: "El archivo está vacío."
            });
        } else {
            this.setState({
                fileToSave: event.target.files[0],
                fileName: event.target.files[0].name,
            });
        }
    }

    /**
     * Función que sube el archivo por medio de una servicio en el back
     * Realiza las validaciones de que haya un archivo, que haya url para la petición,
     * y si hay params que sean del tipo requerido.
     * También llama a la función especificada en "action" en caso de que haya.
     */
    uploadFile() {
        if (this.state.fileToSave === null) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Seleccione un archivo.'
            });
        } else if ((this.props.urlAction === null) || (this.props.urlAction === "")) {
            console.error("No se proporcionó url de la acción.");
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: "No se pudo guardar el documento"
            });
        } else {
            let paramsAux = {};
            let isErrorParams = false;
            if ((this.props.params) && (this.props.params !== "")) {
                typeof this.props.params === "object" ?
                    paramsAux = this.props.params :
                    isErrorParams = true;
            }
            if (!isErrorParams) {
                this.fileService.uploadFile(this.state.fileToSave, this.props.urlAction, paramsAux)
                    .then(res => {
                        if (res.message && (res.message === 'Success' || res.message === 'true')) {
                            this.growl.show({
                                severity: 'success', summary: 'Éxito.',
                                detail: 'Se ha cargado el archivo con éxito'
                            });
                        } else {
                            if (res.errors && (res.errors.length > 0)) {
                                this.growl.show({
                                    severity: 'error', summary: 'Error.',
                                    detail: res.errors.join(", ")
                                });
                            } else if (res.error && res.error !== '') {
                                this.growl.show({
                                    sticky: true,
                                    severity: 'error', summary: 'Error.',
                                    detail: (
                                       this.getDetail(res.error)
                                    ),
                                });

                            }
                        }
                        return this.props.action ? this.props.action() : "";
                    });

                this.setState({
                    fileToSave: null,
                    displayDialog: false,
                    fileName: '',
                });
            } else {
                console.error("Los parametros deben ser del tipo objeto.");
                this.growl.show({
                    severity: 'error', summary: 'Error.',
                    detail: "No se pudo guardar el documento"
                });
            }
        }
    }

    getDetail(strDetail){
        let detailArray = strDetail.split("\n");
        if (detailArray.length > 0){
            return detailArray.map((item) =>
                <p className={"secondary-text"}>
                    {item}</p>
            );
        }
    }

    /**
     * Función que cierra el cuadro de diálogo
     */
    onHideDialog() {
        this.setState({displayDialog: false});
    }

    onHidePreviewDialog() {
        this.setState({displayDialogPreview: false, displayDialog: false});
    }

    getButtonOpen(){
        return <Button type="button" iconPos="left"
                       label={this.props.titleButton ?
                           this.props.titleButton : "Cargar Archivo"}
                       className={this.props.className ? this.props.className : ""}
                       onClick={this.openUploadFile}
        />
    }
    getDialogHeader(){
        return <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                <h2 className={"secondary-text"}> {this.props.titleHeader ?
                    this.props.titleHeader : "Cargar Archivo Disponible"}</h2>
            </div>
            <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.3em'}}>
                <Button label="Cancelar" onClick={this.onHideDialog}
                        className="p-button-secondary"/>
            </div>
            <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.3em'}}>
                <Button label="Guardar" onClick={this.uploadFile}/>
            </div>
        </div>;
    }

    getDialogPreviewHeader(){
        return <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                <h2>Vista Previa</h2>
            </div>
            <div className="p-col-12 p-md-6 p-lg-4" style={{padding: '.3em'}}>
                <Button label="Aceptar" onClick={this.onHidePreviewDialog}/>
            </div>
        </div>;
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let buttonOpen = this.getButtonOpen();
        let dialogHeader =this.getDialogHeader();
        let dialogPreviewHeader = this.getDialogPreviewHeader();

        let uploadMessagesGrowl = <Growl ref={(el) => this.growl = el} style={{textAlign: 'left',}}/>;

        const {displayDialog, fileName, displayDialogPreview} = this.state;

        return <PresvalUploadFileView buttonOpen={buttonOpen}
                                      displayDialog={displayDialog}
                                      displayDialogPreview={displayDialogPreview}
                                      onHideDialog={this.onHideDialog}
                                      onUpload={this.onUpload}
                                      dialogHeader={dialogHeader}
                                      dialogPreviewHeader={dialogPreviewHeader}
                                      fileName={fileName}
                                      uploadMessagesGrowl={uploadMessagesGrowl}
                                      instructions={(this.props.instructions ? this.props.instructions : "")}
        />

    }
};

UploadFileContainer.propTypes = {
    type: PropTypes.array.isRequired,
    errorTypeMessage: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    errorSizeMessage: PropTypes.string.isRequired,
    urlAction: PropTypes.string.isRequired,
    params: PropTypes.object,
    action: PropTypes.func,
    titleButton: PropTypes.string,
    className: PropTypes.string,
    titleHeader: PropTypes.string,
    instructions: PropTypes.string
}